import {
  Timeline as MuiTimeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

type Item = {
  dot: ReactNode;
  content: ReactNode;
};

type TimelineProps = {
  readonly items: Item[];
};

export const Timeline = ({ items }: TimelineProps) => (
  <MuiTimeline
    sx={{
      padding: 0,
      [`& .${timelineItemClasses.root}:before`]: {
        flex: 0,
        padding: 0,
      },
    }}
  >
    {items.map((item, index) => (
      <TimelineItem key={index}>
        <TimelineSeparator sx={{ transform: 'translateY(20px)' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '28px',
              height: '28px',
              borderRadius: '999px',
              border: (theme) => `1px solid ${theme.palette.border.emphasised}`,
            }}
          >
            {item.dot}
          </Box>
          {index < items.length - 1 && (
            <TimelineConnector sx={{ width: '1px', background: (theme) => theme.palette.border.emphasised }} />
          )}
        </TimelineSeparator>
        <TimelineContent>{item.content}</TimelineContent>
      </TimelineItem>
    ))}
  </MuiTimeline>
);
